import EditProfileModal from './EditProfileModal'

export default EditProfileModal
